import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';

export type LabelStyles = VariantProps<typeof labelStyles>;
export const labelStyles = cva('', {
  variants: {
    variant: {
      unstyle: '',
      secondary: 'pb-2 text-caption leading-4 text-neutral-800',
    },
    sizeVariant: {
      xs: 'text-body-small',
      base: 'text-body',
    },
  },
  defaultVariants: {
    sizeVariant: 'base',
    variant: 'unstyle',
  },
});
type Props = {
  required?: boolean;
  htmlFor?: string;
  className?: string;
} & LabelStyles;

const Label: FC<PropsWithChildren<Props>> = ({
  children,
  required = false,
  htmlFor,
  className,
  sizeVariant,
  variant,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames(
        labelStyles({ sizeVariant, variant }),
        {
          "after:px-1 after:text-xl after:text-red-500 after:content-['*'] font-inter":
            required,
        },
        className
      )}
    >
      {children}
    </label>
  );
};

export default Label;
